import { lazy } from 'react';
import { captureException, sessionStorage } from '../utils';
import { SENTRY_ERROR_TYPES } from '../constants';

export const lazyWithRetry = (componentImport, webpackChunkName = '') => {
	return lazy(async () => {
		const pageHasAlreadyBeenForceRefreshed = JSON.parse(
			sessionStorage.getItem('page-has-been-force-refreshed') || 'false',
		);

		try {
			const component = await componentImport();

			sessionStorage.setItem('page-has-been-force-refreshed', 'false');

			return component;
		} catch (error) {
			if (!pageHasAlreadyBeenForceRefreshed) {
				// Assuming that the user is not on the latest version of the application.
				// Let's refresh the page immediately.
				sessionStorage.setItem('page-has-been-force-refreshed', 'true');
				return window.location.reload();
			}
			// The page has already been reloaded
			// Assuming that user is already using the latest version of the application.
			// Let's let the application crash and raise the error & send the same error on sentry.

			captureException(error, {
				tags: {
					chunkLoadFailed: webpackChunkName,
					errorType: SENTRY_ERROR_TYPES.ChunkLoadFailed,
				},
			});
			throw error;
		}
	});
};
